import ReactDOMServer from "react-dom/cjs/react-dom-server.browser.production.min.js";

export default ReactDOMServer;
export const {
  renderToNodeStream,
  renderToStaticMarkup,
  renderToStaticNodeStream,
  renderToString,
  version,
} = ReactDOMServer;
// This file exists simply to apply __esModule: true to the module
export const __esModule = true;
